import React, {useContext, useState} from 'react';
import AuthContext from "../../Services/AuthContext";
import StyledModal from "../../Component/StyledModal";
import {FormControlLabel, TextField} from "@mui/material";
import StyledSelect from "../../Component/StyledSelect";
import Switch from "@mui/material/Switch";


function AddUserRole(props) {
    const title = 'Dodaj Prawa Użytkownikowi';
    const description = 'Tutaj możesz dodać organizatora odpowiedzialnego za wydarzenie. Administrator ma dostęp do wszystkich danych organizacji, wraz z zarządzaniem kontami użytkowników';

    const [user] = useContext(AuthContext);
    const [email, setEmail] = useState('');
    const [admin, setAdmin] = useState(false);

    function _send() {
        const formData = {
            email: email,
            admin: admin
        };
        fetch(`/api/organizer/${props.data}/user`, {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                props.onSuccess(data);
                props.dismiss();
            })
            .catch(err => { console.log(err) })
    }

    return (<StyledModal isOpen={props.data !== false} title={title} description={description} send={_send} dismiss={props.dismiss}>
                <TextField
                    onChange={(e) => setEmail(e.target.value)}
                    label='Email'
                    value={email}
                    variant="outlined"
                    fullWidth
                />
                <FormControlLabel control={<Switch onChange={() => setAdmin(a => !a)} checked={admin} />} label="Administrator" />

        </StyledModal>);
}
export default AddUserRole;